import AvatarPlaceholder from 'common/AvatarPlaceholder/AvatarPlaceholder';
import { resolveJudgeCategory } from 'services/EphanDataService';
import './JudgeCard.css';
import '../../Catalog.css';
import { useLanguage } from 'hooks/useLanguage';

export default function JudgeCard({ judge }) {
  const language = useLanguage();

  const surname = (judge.surname || '').trim();
  const name = (judge.name || '').trim();
  const fullName = `${surname} ${name}`.trim();

  const category = resolveJudgeCategory(judge.judgeCategory);

  return (
    <div className='catalog-card judge-card'>
      <div className='img-wrapper'>
        {judge.avatar ? <img src={judge.avatar} alt='' loading='lazy' /> : <AvatarPlaceholder />}
      </div>

      <div className='card-body'>
        <h2 className='card-name'>{fullName || name || surname}</h2>

        {category && (
          <span className='judge-class'>
            <span className='visually-hidden'>{language === 'en' ? 'Category: ' : 'Категорія: '}</span>
            {language === 'en' ? category.label : category.labelUa}
          </span>
        )}
      </div>
    </div>
  );
}
